<template>
    <div class="card">
        <div class="card-body text-center py-4">
            <i :class="`${icon} text-muted fa-2x mb-2`"></i>
            <h6 class="text-muted mb-1">{{ title }}</h6>
            <p class="text-xs text-muted mb-0">{{ message }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MessageCard',
    props: {
        icon: {
            type: String,
            default: 'fas fa-info-circle'
        },
        title: {
            type: String,
            default: 'No Request Submitted'
        },
        message: {
            type: String,
            default: 'Submit a request from the Form Data tab to see status updates here.'
        }
    }
}
</script>